import React from 'react';
import {
  Layout,
  Button,
  message,
  Switch,
  Avatar,
  Icon
} from 'antd';

import { withFirebase } from 'services/firebase';
import { API_URL } from 'config/constants/routes';

class Configuration extends React.Component {
  state = {
    userData: { companyId: null },
    companyData: { is_widget_visible: false },
  }

  async componentWillMount() {
    const userData = await this.props.firebase.userData();
    const companyData = await this.props.firebase.companyData(userData.companyId);
    this.setState({ userData, companyData });

  }

  oauthUrl = () => {
    const { companyId } = this.state.userData;
    const redirectUrl = `${API_URL}/slack/oauth`;
    return `https://slack.com/oauth/authorize?client_id=511517830229.594680467778&scope=incoming-webhook,chat:write:bot&state=${companyId}&redirect_uri=${redirectUrl}`;
  }

  widgetSnippet = () => {
    const { companyId } = this.state.userData;
    return `<convodo-widget company-id="${companyId}"></convodo-widget>`;
  }


  scriptSnippet = () => {
    return `<script src='https://unpkg.com/convodo-widget@latest/dist/convodo-widget.min.js'></script>`;
  }

  copySnippetToClipboard = () => {
    var range = document.createRange();
    range.selectNode(document.getElementById("snippet-input"));
    window.getSelection().removeAllRanges(); // clear current selection
    window.getSelection().addRange(range); // to select text
    document.execCommand("copy");
    window.getSelection().removeAllRanges();// to deselect
    setTimeout(() => {
      message.info('Copied snippet to clipboard')
    }, 100);
  }

  onSwitchChange = checked => {
    const { companyId } = this.state.userData;
    const companyRef = this.props.firebase.company( companyId );
    companyRef.update({is_widget_hidden: checked});
    this.setState({ companyData: { is_widget_hidden: checked }});
  }

  switchHiddenSnippet = () => {
    if (this.state.companyData.is_widget_hidden) {
      return 'CONVODO IS HIDDEN ON YOUR WEBSITE'
    } else {
      return 'CONVODO IS SHOWING ON YOUR WEBSITE'
    }
  }



  render() {

    return (
      <Layout.Content>
        <Layout className="main-container" style={{backgroundColor:'#EDF4F4', overflow:'scroll'}}>
          <Layout.Content>    

            {this._renderWelcomeMessage()}
            {/* Code snippet */}
            <div style={{
              width: '100%',
              maxWidth: '900px',
              backgroundColor: '#fff',
              boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
              borderRadius: '4px',
              color:'#375972',
              margin: 'auto',
              marginTop: '40px',
            }}>
              <div style={{display: 'flex', padding: '32px'}}>
                <Avatar size={48} icon="code" style={{
                  backgroundColor: '#375972',
                  color:'#D7EEFF',
                  minWidth: '48px'
                }}/>
                <div style={{
                  marginLeft:'32px',
                  marginRight: '72px'
                }}>
                  <p style={{
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: '24px',
                    margin: 0
                  }}>
                    Install Convodo on your website
                  </p>
                  <p style={{
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: '16px',
                    color: '#7B9DB6',
                    marginTop: '8px',
                    marginBottom: '0px'
                  }}>
                    Copy and paste the following code before the end body tag on every page you want Convodo to appear
                  </p>
                </div>
              </div>
              <div style={{
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'flex-start',
                paddingLeft: '112px', 
                paddingRight: '112px',
                backgroundColor: '#E9F4FA', 
                borderRadius:'0px 0px 4px 4px'
              }}>
                <p style={{
                      fontStyle: 'normal',
                      fontWeight: '600',
                      fontSize: '10px',
                      color: '#AAC1D2',
                      marginTop: '24px',
                      marginBottom: '0px'
                }}>
                  YOUR CUSTOM CODE SNIPPET
                </p>

                <div style={{
                  marginTop:'16px',
                  backgroundColor: '#FFFFFF',
                  width: '100%',
                  borderRadius: '4px',
                  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
                  display: 'flex',
                  alignItems: 'center',
                }}>
                  <Avatar size={48} icon="code" style={{
                    backgroundColor: '#E9F4FA',
                    color:'#B6D2E7',
                    minWidth: '48px',
                    margin:'16px'
                  }}/>
                  <p
                    id="snippet-input" 
                    style={{
                      width: '100%',
                      fontStyle: 'normal',
                      fontWeight: 'normal',
                      fontSize: '12px',
                      color: '#7B9DB6',
                      margin: '0px',
                      marginRight: '16px'
                    }}>
                    {this.scriptSnippet()} 
                    <br/>
                    {this.widgetSnippet()}
                  </p>
                </div>
                <Button 
                  type="primary" 
                  size="large" 
                  icon="copy" 
                  onClick={this.copySnippetToClipboard}
                  style={{width: 'auto', backgroundColor: '#375972', marginTop: '24px', marginBottom: '24px'}}
                  >
                  Copy
                </Button>
              </div>
            </div>

            {/* Add to Slack */}
            <div style={{
              width: '100%',
              maxWidth: '900px',
              backgroundColor: '#fff',
              boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
              borderRadius: '4px',
              color:'#375972',
              margin: 'auto',
              marginTop: '40px'
            }}>
              <div style={{display: 'flex', padding: '32px'}}>
                <Avatar size={48} icon="slack" style={{
                  backgroundColor: '#375972',
                  color:'#D7EEFF',
                  minWidth: '48px'
                }}/>
                <div style={{
                  marginLeft:'32px',
                  marginRight: '72px'
                }}>
                  <p style={{

                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: '24px',
                    margin: 0
                  }}>
                    Add to Slack
                  </p>
                  <p style={{
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: '16px',
                    color: '#7B9DB6',
                    marginTop: '8px',
                    marginBottom: '0px'
                  }}>
                    Get a notification everytime someone calls you on Convodo
                  </p>
                </div>
                <div style={{marginLeft: 'auto'}}>
                  {this._renderSlackLink()}
                </div>
              </div>
            </div>     

          {/* Turn on/off */}
            <div style={{
              width: '100%',
              maxWidth: '900px',
              backgroundColor: '#fff',
              boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
              borderRadius: '4px',
              color:'#375972',
              margin: 'auto',
              marginTop: '40px',
              marginBottom: '40px'
            }}>
              <div style={{display: 'flex', padding: '32px'}}>
                <Avatar size={48} icon="eye-invisible" style={{
                  backgroundColor: '#375972',
                  color:'#D7EEFF',
                  minWidth: '48px'
                }}/>
                <div style={{
                  marginLeft:'32px',
                  marginRight: '72px'
                }}>
                  <p style={{
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: '24px',
                    margin: 0
                  }}>
                    Hide from your website
                  </p>
                  <p style={{
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: '16px',
                    color: '#7B9DB6',
                    marginTop: '8px',
                    marginBottom: '0px'
                  }}>
                    Toggle convodo off while you get your <span style={{fontStyle: 'italic'}}>zzz’s</span> 
                  </p>
                </div>
                <div style={{
                  marginLeft: 'auto',
                  display: 'flex', 
                  flexDirection: 'column',
                  alignItems: 'flex-end'
                }}>
                  <p style={{
                        fontStyle: 'normal',
                        fontWeight: '600',
                        fontSize: '10px',
                        color: '#AAC1D2',
                        margin: '0px',
                        marginBottom: '8px'
                  }}>
                    {this.switchHiddenSnippet()}
                  </p>
                  <Switch
                    checked={this.state.companyData.is_widget_hidden}
                    className="copy-snippet-switch"
                    onChange={this.onSwitchChange}
                  />
                </div>
              </div>
            </div>          

          </Layout.Content>
        </Layout>
      </Layout.Content>
    );
  }

  _renderSlackLink = () => (
    <a href={this.oauthUrl()}>
      <p style={{
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        color: '#375972',
      }}>
        <Icon type="api" /> Connect to my slack
      </p>
    </a>
  )

  _renderWelcomeMessage = item => {
    const {conversation_count} = this.state.companyData
    const {first_name} = this.state.userData
    const welcomeMessage = (
      `Hey ${first_name}, thanks for signing up!
      You need to install Covodo to start taking video calls on your website 🎉`
    );

    if (conversation_count == null || conversation_count === 0) {
      return (
        <div className="welcome-containter">
          {welcomeMessage}
        </div>
      );
    }
  }
}

export default withFirebase(Configuration);
